import { useHistory, useLocation } from 'react-router-dom';

import {
  canUseMosPosMenuMasterPage,
  redirect404MosPosMenuMasterPage,
} from '@/lib/AccessControl';
// barrel には jest で失敗する export が含まれているため直接読み込みます
// (src/services/AuthEnterprise/hooks/index.ts の @warning を参照)。
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks/useManagerAccountMe';
import {
  MosPosImportResult,
  MosPosMenuMasterError,
  useMosPosMenuMasterList,
} from '@/services/MosPosMenuMaster';

/** SCR010 の登録成功後に replace で渡ってくる state。 */
type ListLocationState = {
  importResult?: MosPosImportResult;
};

export const useMosPosMenuMasterListPage = () => {
  const history = useHistory();
  const location = useLocation<ListLocationState | undefined>();
  const { managerAccountMe } = useManagerAccountMe();
  /* アクセス制御 */
  redirect404MosPosMenuMasterPage(history, managerAccountMe);

  // アカウントの読み込みが完了するまでは false になるため、判定前のリクエストが
  // 発生しません。
  const canUse = canUseMosPosMenuMasterPage(managerAccountMe);
  const { data, isLoading, error } = useMosPosMenuMasterList(canUse);

  const schemaMigrationRequired =
    error instanceof MosPosMenuMasterError &&
    error.code === 'POS_MENU_SCHEMA_MIGRATION_REQUIRED';

  return {
    importResult: location.state?.importResult,
    businessDate: data?.business_date ?? '',
    summary: data?.summary,
    menus: data?.menus ?? [],
    // enabled が false の間 react-query は idle になり isLoading が false になります。
    // そのまま返すと空状態を描画してしまうため、読み込み中として扱います。
    isLoading: !canUse || isLoading,
    error,
    schemaMigrationRequired,
  };
};
